class Debug {
  static enabled = true;
}

export { Debug };
